export interface BlogPost {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  date: string;
  publishedAt: string;
  readTime: string;
  image: string;
  content: string[];
  highlights: string[];
  faqs: Array<{ q: string; a: string }>;
}

export const BLOG_POSTS: BlogPost[] = [
  {
    id: "01",
    slug: "dsg-sanziman-bakimi-ne-zaman-yapilmali",
    title: "DSG Şanzıman Bakımı Ne Zaman Yapılmalı?",
    excerpt:
      "DSG şanzıman bakım periyodu yalnızca kilometreye göre değil; sürüş stili, trafik yoğunluğu ve ısı yüküne göre değerlendirilmelidir.",
    category: "Şanzıman",
    date: "03 Nisan 2026",
    publishedAt: "2026-04-03",
    readTime: "7 dk",
    image: "/images/kiiii.png",
    content: [
      "DSG şanzımanlar hassas çalışma prensibi nedeniyle düzenli bakım ister.",
      "Şehir içi yoğun kullanım, sık dur-kalk ve yüksek ısı yükü bakım ihtiyacını artırabilir.",
      "Vites geçişlerinde gecikme, kalkışta titreme veya vuruntu gibi belirtiler ihmal edilmemelidir.",
      "Doğru teşhis ekipmanlarıyla yapılan bakım, gereksiz parça değişimini azaltır.",
      "Önleyici bakım, yüksek maliyetli mekatronik arızalarının önüne geçebilir.",
    ],
    highlights: [
      "Yoğun şehir içi kullanımda bakım periyodu daha kısa tutulmalıdır.",
      "Canlı veri analizi yapılmadan parça değişimi önerilmemelidir.",
      "Şanzıman yağı ve sarf malzemelerde kalite standardı kritiktir.",
      "Erken müdahale toplam onarım maliyetini düşürür.",
    ],
    faqs: [
      {
        q: "DSG bakımını geciktirirsem ne olur?",
        a: "Bakımın gecikmesi sürtünme ve ısı kaynaklı aşınmayı artırabilir, bu da daha yüksek onarım maliyetlerine yol açabilir.",
      },
      {
        q: "Her DSG aynı periyotta mı bakım ister?",
        a: "Hayır. Model, kullanım yoğunluğu ve sürüş koşulları periyodu değiştirir.",
      },
    ],
  },
  {
    id: "02",
    slug: "vag-araclarda-periyodik-bakim-kontrol-listesi",
    title: "VAG Araçlarda Periyodik Bakım Kontrol Listesi",
    excerpt:
      "Periyodik bakım yalnızca rutin parça değişimi değil, aracın güvenlik ve performansını birlikte koruyan bütüncül bir süreçtir.",
    category: "Periyodik Bakım",
    date: "28 Mart 2026",
    publishedAt: "2026-03-28",
    readTime: "8 dk",
    image: "/images/cg-svc-engine.jpg",
    content: [
      "Periyodik bakım; yağ ve filtre değişiminin yanında fren, süspansiyon ve elektronik kontrolleri de kapsar.",
      "Lisanslı teşhis cihazlarıyla yapılan taramalar gizli arızaları erken yakalamaya yardımcı olur.",
      "Düzenli bakım geçmişi araç değerini ve güvenilirliğini destekler.",
      "Akü, klima, soğutma devresi ve lastik aşınması da kontrol listesinde yer almalıdır.",
      "Standart checklist ile bakım, güvenlik ve maliyet yönetimi açısından kritik rol oynar.",
    ],
    highlights: [
      "Fren ve süspansiyon kontrolleri en az motor bakımı kadar önemlidir.",
      "Elektronik tarama, henüz belirti vermeyen arızaları yakalar.",
      "Düzenli servis kaydı ikinci el değerini destekler.",
      "Bakım süreci araç kullanım koşullarına göre planlanmalıdır.",
    ],
    faqs: [
      {
        q: "Periyodik bakımda hangi parçalar değişir?",
        a: "Araç modeline ve kilometreye göre değişir. Yağ, filtreler ve gerekli sarf ürünleri temel kalemlerdir.",
      },
      {
        q: "Bakımı sadece kilometreye göre mi yaptırmalıyım?",
        a: "Kilometre önemlidir ancak süre ve kullanım koşulları da en az kilometre kadar belirleyicidir.",
      },
    ],
  },
  {
    id: "03",
    slug: "ariza-isigi-yandiginda-ne-yapmalisiniz",
    title: "Arıza Işığı Yandığında Ne Yapmalısınız?",
    excerpt:
      "Gösterge panelindeki uyarıların doğru yorumlanmaması ciddi hasarlara yol açabilir. İlk adım doğru teşhis ve güvenli müdahaledir.",
    category: "Arıza Teşhisi",
    date: "20 Mart 2026",
    publishedAt: "2026-03-20",
    readTime: "6 dk",
    image: "/images/cg-svc-diag.jpg",
    content: [
      "Arıza lambası her zaman kritik arıza anlamına gelmez ancak ihmal edilmemelidir.",
      "Kırmızı uyarılarda aracı zorlamadan güvenli bir noktada durmak gerekir.",
      "İlk teşhis kayıtları kök neden analizinde kritik öneme sahiptir.",
      "Doğru teşhis, gereksiz parça değişimi ve zaman kaybını önler.",
      "Erken müdahale güvenlik risklerini azaltır ve kalıcı çözüm sağlar.",
    ],
    highlights: [
      "Kırmızı uyarı lambalarında sürüşe devam edilmemelidir.",
      "Aracı zorlamadan güvenli noktaya almak hasar riskini azaltır.",
      "İlk arıza kayıtları detaylı incelenmelidir.",
      "Erken teşhis, toplam onarım maliyetini düşürür.",
    ],
    faqs: [
      {
        q: "Check engine ışığı yanınca hemen stop etmeli miyim?",
        a: "Işığın rengi ve aracın davranışı belirleyicidir. Şiddetli titreme veya hararet varsa güvenli şekilde durdurmalısınız.",
      },
      {
        q: "Arıza lambası söndüyse sorun bitmiş midir?",
        a: "Her zaman değil. Geçici görünen sorunlar kayıtlı kalabilir; diagnostik kontrol önerilir.",
      },
    ],
  },
];
